import React, { useEffect } from 'react';

import List from '@sv-support-sdk/ui-components/src/components/Lists/List';
import Headline from '@sv-support-sdk/ui-components/src/components/Typography/Headline';

import LoaderFallback from '../../components/Feedback/Loader/LoaderFallback';
import PageContentInner from '../../components/Layout/Page/PageContentInner';
import Card from '../../components/Panels/Card';

import { useAppDispatch, useAppSelector } from '../../store/hooks';
import { selectCategories, selectCategoriesLoading } from '../../store/selectors/faq';
import useMobileDetect from '../../hooks/useMobileDetect';
import faqActions from '../../store/actions/faq';
import { $l } from '../../locales';
import { routes } from '../../routing';
import { SUPPORT_HELP_CENTER_FAQ_CARD } from '../../constants/qaAttributes';

const FAQ = () => {
  const dispatch = useAppDispatch();
  const isMobile = useMobileDetect();
  const categories = useAppSelector(selectCategories);
  const loading = useAppSelector(selectCategoriesLoading);

  useEffect(() => {
    dispatch(faqActions.getCategories());
  }, [dispatch]);

  if (loading) {
    return (
      <PageContentInner height="full">
        <LoaderFallback />
      </PageContentInner>
    );
  }

  if (!categories.length) {
    return null;
  }

  return (
    <PageContentInner>
      <Headline className="indent-xl-bottom">{$l('FAQ.TITLE')}</Headline>
      <List
        type="grid"
        columns={isMobile ? undefined : '3'}
        gap={isMobile ? '16' : '24'}
        indents="0-0-24"
      >
        {categories &&
          categories.map((category) => (
            <Card
              key={category.id}
              size="small"
              border={isMobile ? 'bold' : undefined}
              link={`${routes.faq}/${category.slug}`}
              title={category.name}
              icon={{ name: category.image ? `32--${category.image}` : '32--dashboard-outlined' }}
              qaId={`${SUPPORT_HELP_CENTER_FAQ_CARD}-${category.slug}`}
            />
          ))}
      </List>
    </PageContentInner>
  );
};

export default FAQ;
